<template>
	<div class="form-group group-checkbox-week-days">
		<label :for="name">{{ placeholder }}</label>
		<div class="items">
			<label v-for="option in options" :key="option.value" class="item">
				<input type="checkbox" :name="name" :id="option.text" :value="option.value" v-model="selected" @change="onChange" v-validate="rules" :data-vv-as="placeholder">
				<span class="day">{{ option.text }}</span>
			</label>
		</div>
		<span v-if="rules" v-show="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: [
		'value',
		'name',
		'placeholder',
		'rules'
	],
	data () {
		return {
			options: [
				{ text: 'M', value: 1  },
				{ text: 'T', value: 2  },
				{ text: 'W', value: 4  },
				{ text: 'T', value: 8  },
				{ text: 'F', value: 16 },
				{ text: 'S', value: 32 },
				{ text: 'S', value: 64 }
			],
			selected: []
		}
	},
	watch: {
		value () {
			this.selected = []
			this.options.forEach(element => {
				if (element.value & this.value) {
					this.selected.push(element.value)
				}
			})
		}
	},
	computed: {
		result () {
			if (this.selected.length) {
				return this.selected.reduce(function (acc, val) {
					return acc + val
				})
			}
			return 0
		}
	},
	methods: {
		onChange () {
			this.$emit('input', this.result)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/pillboxV2/InputWeek.vue